require('./cardLastMovementsMoreInfoRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ actions
const { getCardMovementInstallmentsChart } = require('actions/cardMovementInstallmentChart');
const cancelPostPaymentActions = require('actions/cancelPostPayment');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatNumber } = require('utilities/currencyHelper');
const { getPlainAmountObject, formatCurrency } = require('utilities/currencyHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ components
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const CardMovementInstallmentChart = require('components/cards/cardMovementInstallmentChart/cardMovementInstallmentChart');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const { CARD_MOVEMENTS_LIQUIDATED, CARD_CREDIT, CARD_ECARD, HYPHEN } = require('constants/index');
const { CARD_CANCEL_DEFERRED_PURCHASE_ENABLED } = require('constants/flagBasedFeatures.js');


class CardLastMovementsMoreInfoRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isInstallmentModalOpen: false
        };

        this.handleToggleInstallmentModal = this.handleToggleInstallmentModal.bind(this);
        this.handleCancelDeferPurchase = this.handleCancelDeferPurchase.bind(this);
    }

    componentDidMount() {
        const {
            getCardMovementInstallmentsChart,
            immTransaction,
            requestCancelPostPayData,
        } = this.props;

        getCardMovementInstallmentsChart(immTransaction.get('cardId'), immTransaction.get('id'));
        requestCancelPostPayData(immTransaction.get('cardId'));
    }

    handleToggleInstallmentModal() {
        this.setState({
            isInstallmentModalOpen: !this.state.isInstallmentModalOpen
        });
    }

    handleCancelDeferPurchase() {
        const { history, immTransaction } = this.props;
        const cardId = immTransaction.get('cardId');
        const movementId = immTransaction.get('id');
        history.push(`/myprofile/cards/${cardId}/cancel-defer-purchase/${movementId}`);
    }

    render() {
        const {
            id,
            immCancelPostPayData,
            immCardMovementInstallmentsChart,
            immCards,
            immFlagBasedFeatures,
            immMovements,
            immTransaction,
        } = this.props;

        const categoryBank = formatText('categories-Transferencias, gastos bancarios y préstamos');
        const subCategoryBank = 'Gastos y comisiones bancarias';
        const cardId = immTransaction.get('cardId');
        const immCard = immCards.getIn(['byId', cardId]);
        const wasLiquidated = immTransaction.get('contractStatus') === CARD_MOVEMENTS_LIQUIDATED;
        const isCreditCard = immCard.get('type') === CARD_CREDIT;
        const transactionId = immTransaction.get('id');
        const routeWizard = `/myprofile/cards/${cardId}/cancel-post-payment/${transactionId}`;
        const isEcard = immCard.get('type') === CARD_ECARD;
        const isCharity = immCard.get('isCharity') &&
            getPlainAmountObject(immTransaction.get('import')).amount <= 0 &&
            immTransaction.get('category') !== categoryBank &&
            immTransaction.get('subcategory') !== subCategoryBank;

        let settlementDateItem, NFCPaymentItem, charityInformation;
        let repaymentChartButton;
        let immInstallments;

        if (isCharity && immMovements.get('hasNGOsMovement')) {
            const amountRound = Math.ceil(Math.abs(getPlainAmountObject(immTransaction.get('import')).amount)) - Math.abs(getPlainAmountObject(immTransaction.get('import')).amount);
            const currency = formatCurrency(getPlainAmountObject(immTransaction.get('import')).currency);
            const injectedStrings = [
                formatNumber(amountRound.toFixed(2)),
                currency
            ];

            const contentCharityInformation = amountRound > 0
                ?
                    <FormattedText value="cardTransactionsDetails-charityAmount" injectedStrings={injectedStrings} />
                :
                    <FormattedText value="cardTransactionsDetails-charityEmptyAmount" />;

            charityInformation = (
                <div className="card-last-movements-more-info-row__charity-movements">
                    {contentCharityInformation}
                </div>
            )
        }

        if (isCreditCard && wasLiquidated) {
            let settlementDate = HYPHEN;

            if (immTransaction.get('settlementDate') !== '0001-01-01') {
                settlementDate = DateHelper.formatDate(immTransaction.get('settlementDate'));
            }

            settlementDateItem = (
                <OKTableRowDetailsItem
                    title={formatText('cardTransactionsDetails-operationDate')}
                    value={settlementDate}
                />
            );
        }

        if (!isEcard) {
            const NFCPayment = formatText('cardTransactionsDetails-NFCPayment');
            const NFCPaymentValue = immTransaction.get('isNFC')
                ? formatText('common-yes').toUpperCase()
                : formatText('common-no').toUpperCase();
            NFCPaymentItem = <OKTableRowDetailsItem title={NFCPayment} value={NFCPaymentValue} />;
        }

        if (immTransaction.get('deferPaymentIndicator') === 'F') { // F means that was deferred.
            immInstallments = immCardMovementInstallmentsChart.getIn(['installmentData', 'installmentList']);
            const cardLastMovementsClassName = contactCenterClassName('card-last-movements-more-info-row__link-btn');

            let cancelDeferPurchaseButton = null;
            let immCancelDeferPurchaseState;

            if (immFlagBasedFeatures.get(CARD_CANCEL_DEFERRED_PURCHASE_ENABLED) && immCancelPostPayData.get('postPaymentDetails').size > 0) {
                immCancelDeferPurchaseState = immCancelPostPayData.get('postPaymentDetails').find(immPayment => {
                    return immPayment.get('fecopera') === immTransaction.getIn(['extra', 'operationDate']) &&
                        immPayment.get('liamovto') === immTransaction.getIn(['extra', 'dayMovementNumber']);
                });
            }

            if (!__CONTACT_CENTER__ && !immCardMovementInstallmentsChart.get('isFetching') &&
                !!immCancelDeferPurchaseState && immCancelDeferPurchaseState.get('indCancel') === 'N') {
                cancelDeferPurchaseButton = (
                    <span className="card-last-movements-more-info-row__cancel-defer-purchase-button">
                        <OKButton
                            modifier="ghost"
                            onClick={this.handleCancelDeferPurchase}
                        >
                            <FormattedText value="cardTransactionsDetails-cancelDeferPurchaseButtonText" />
                        </OKButton>
                    </span>
                );
            }

            repaymentChartButton = (
                <div className="card-last-movements-more-info-row__installments-chart-button">
                    <ContactCenterRender>
                        <OKButton
                            modifier="secondary"
                            to={routeWizard}
                        >
                            <FormattedText value="cardTransactionsDetails-cancelPostponedMovementBtn" />
                        </OKButton>
                    </ContactCenterRender>
                    <OKButton
                        id="btn__cardLastMovementsMoreInfoRow__installments-chart"
                        modifier="secondary"
                        onClick={this.handleToggleInstallmentModal}
                        loading={immCardMovementInstallmentsChart.get('isFetching')}
                        disabled={immCardMovementInstallmentsChart.get('error')}
                        customLinkClassName={cardLastMovementsClassName}
                    >
                        <FormattedText value="cardTransactionsDetails-cardTransactionsDetails_installmentChart" />
                    </OKButton>
                    {cancelDeferPurchaseButton}
                </div>
            );
        }

        const contentModal = (
            <CardMovementInstallmentChart immInstallments={immInstallments} />
        );

        return (
            <tr className="card-last-movements-more-info-row" id={id}>
                <td className="container-fluid" colSpan="7">
                    <div className="card-last-movements-more-info-row__content">
                        <OKTableRowDetails title="cardTransactionsDetails-detailInfo">
                            <OKTableRowDetailsItem
                                title={formatText('cardTransactionsDetails-description')}
                                value={immTransaction.get('description')}
                            />
                            <OKTableRowDetailsItem
                                title={formatText('cardTransactionsDetails-operationHour')}
                                value={immTransaction.get('time') || HYPHEN}
                            />
                            {settlementDateItem}
                            {NFCPaymentItem}
                            {repaymentChartButton}
                        </OKTableRowDetails>
                        {charityInformation}
                        <OKModal
                            content={contentModal}
                            isOpen={this.state.isInstallmentModalOpen}
                            onCloseCallback={this.handleToggleInstallmentModal}
                            size="extra-large"
                            title="cardPaymentPurchaseDeferralTable-title"
                        />
                    </div>
                </td>
            </tr>
        );
    }
}

CardLastMovementsMoreInfoRow.propTypes = {
    getCardMovementInstallmentsChart: PropTypes.func,
    history: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    immCancelPostPayData: PropTypes.object.isRequired,
    immCardMovementInstallmentsChart: PropTypes.object,
    immCards: PropTypes.object,
    immFlagBasedFeatures : PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    immMovements: PropTypes.object,
    requestCancelPostPayData: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immCancelPostPayData: state.cancelPostPayment,
        immCards: state.cards,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immMovements: state.movements,
        immCardMovementInstallmentsChart: state.cardMovementInstallmentChart,
    }),
    {
        getCardMovementInstallmentsChart: getCardMovementInstallmentsChart,
        requestCancelPostPayData: cancelPostPaymentActions.requestCancelPostPayData,
    }
)(withRouter(CardLastMovementsMoreInfoRow));
